import { createContext } from 'react';

interface IMenuContext {
  handleOpenMenu: Function;
}

export const MenuContext = createContext<IMenuContext>({handleOpenMenu: () => {}});
